import config from "./config";

const USER_KEY = "currentUser";
const LOGGED_IN_KEY = "isLoggedIn";

export function getCurrentUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw || raw === "undefined") return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveCurrentUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  localStorage.setItem(LOGGED_IN_KEY, "true");
}

export function clearCurrentUser() {
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(LOGGED_IN_KEY);
}

export function isLoggedIn() {
  return getCurrentUser() !== null;
}

export function hasSiteAccess(user = getCurrentUser()) {
  const roles = user?.user_roles;
  if (typeof roles === "string") return roles.includes(config.siteAccessRole);
  return Array.isArray(roles) && roles.includes(config.siteAccessRole);
}

export function getAccessToken(user = getCurrentUser()) {
  return user?.access_token || "";
}
